import { Injectable } from '@angular/core';
import {
  jkLib,
  jkRestReturn,
  jkRestReturnClass,
} from 'jk-service';
import { StklmServicePkg } from './stklmPkg.service';
import { Stklm } from '../entity/Stklm-angular';
import { AxiosRequestConfig } from 'axios';

@Injectable({
  providedIn: 'root',
})
export class StklmService extends StklmServicePkg {
  constructor() {
    super();
  }
  async confirm(lm: Stklm, host: string): Promise<jkRestReturn> {
    //let sql = `UPDATE STKLM SET LM005='Y' WHERE LM001='${lm.LM001}' `;

    let ret = new jkRestReturnClass();
    if (lm.KEY1 === '9') {
      alert('已確認');
      ret.clear(true);
      return ret;
    };
    // 期貨
    //if(lm.MarketType === 'TF') {
    let url = host + `/capital/reply?stklm001=` + lm.LM001;
    let config: AxiosRequestConfig = jkLib.axiosConfigInit(
      this.host,
      url,
      'get',
      '',
      undefined
    );

    let bool = await this.doAxios(config, ret);
    if (ret.result) {
      lm.KEY1 = '9';
    }
    /*  let ob = orm.http.get(url);
    ob.subscribe((data: any) => {
      if(data.result) {
        alert('回報成功');
      } else {
        alert('回報失敗');
      }
    });
    } */

    return ret;
  }
}
